<template>
    <div class="overlay" @click.self="closeInfoCard">
        <div class="info-card">
            <div class="modal-header">
                <button class="close-btn" @click="closeInfoCard">×</button>
            </div>
            
            <div class="modal-content">
                <h2>解釋：</h2>
                <div class="scroll-body">
                    <p>{{ desc }}</p>
                    <v-img v-if="this.image" :src="require('../assets/suits/' + this.image)" alt="Image Here" class="desc-image"></v-img>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            desc: String,
            image: String,
        },

        methods: {
            closeInfoCard() {
                this.$emit('close');
            }
        }
    }
</script>

<style scoped>
    .overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(2px);
        z-index: 9000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }

    .info-card {
        background-color: #fff;
        width: 100%;
        max-width: 450px;
        min-height: 200px;
        max-height: 80vh;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        border-radius: 24px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

    @keyframes popIn {
        from { transform: scale(0.95); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
    }

    .modal-header {
        display: flex;
        justify-content: flex-end;
        padding: 12px 15px 0;
    }

    .modal-content {
        padding: 0 25px 25px;
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .modal-content h2 {
        margin-top: 5px;
        margin-bottom: 15px;
        font-size: 20px;
        color: #333;
        text-align: left;
        border-left: 4px solid #4CAF50;
        padding-left: 10px;
    }    
    
    .scroll-body {
        overflow-y: auto;
        padding-right: 5px;
    }

    .scroll-body p {
        font-size: 15px;
        line-height: 1.6;
        color: #555;
        margin-bottom: 15px;
    }

    .desc-image {
        width: 100%;
        border-radius: 12px;
        margin-top: 10px;
        border: 1px solid #eee;
    }

    .close-btn {
        font-size: 24px;
        border: none;
        background: #f8f9fa;
        color: #999;
        cursor: pointer;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
    }

    .close-btn:hover {
        background: #f0f0f0;
        color: #666;
        transform: rotate(90deg);
    }

    /* Custom scrollbar */
    .scroll-body::-webkit-scrollbar {
        width: 4px;
    }
    .scroll-body::-webkit-scrollbar-track {
        background: #f9f9f9;
        border-radius: 10px;
    }
    .scroll-body::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 10px;
    }
</style>